import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  align-self: stretch;
  padding-top: ${props => props.theme.spacing.sp16};
`

export const UserImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  align-self: stretch;
`

export const UploadInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1;
`

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  align-self: stretch;
`

export const InputsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  & > * {
    flex: 1;
  }
`
